// The three panes are a layout grid, not tabular data, so the toolbar and the
// list row share one track template rather than a table's column widths.
export const PANE_TRACKS =
  "minmax(200px, 250px) minmax(240px, 300px) minmax(0, 1fr)";
export const PANE_PADDING_X = "var(--space-4)";
export const PANE_BORDER = "1px solid var(--color-border)";

/** Rows are spaced by a gap on every item but the last. */
export const rowGapSx = (index: number, total: number) => ({
  marginBottom: index === total - 1 ? "0" : "var(--space-2)",
});
